import jQuery from "jquery";

document.addEventListener("DOMContentLoaded", function () {
    const loadmore_button = document.getElementById("load-more__button");

    let currentPage = 2;

    if (loadmore_button) {
        loadmore_button.onclick = function (event) {
            event.preventDefault();
            event.stopPropagation();
            jQuery.ajax({
                type: "POST",
                url: "/wp-admin/admin-ajax.php",
                dataType: "json",
                data: {
                    action: "cb_posts_load_more",
                    paged: currentPage,
                },
                success: function (res) {
                    if (currentPage >= res.max) {
                        jQuery("#load-more__button").hide();
                    } else {
                        currentPage++;
                    }
                    jQuery("#blog-list-inner__inner").append(res.html);
                }
            });
        };
    }

    var canBeLoaded = true, // this param allows to initiate the AJAX call only if necessary
        bottomOffset = 2000;

	jQuery(window).scroll(function () {
        var data = {
            action: "cb_posts_load_more",
            paged: currentPage,
        };
        if (
            jQuery(document).scrollTop() > jQuery(document).height() - bottomOffset && canBeLoaded == true
        ) {
            jQuery.ajax({
                url: "/wp-admin/admin-ajax.php",
                data: data,
                type: "POST",
                dataType: "json",
                beforeSend: function (xhr) {
                    // you can also add your own preloader here
                    // you see, the AJAX call is in process, we shouldn't run it again until complete
                    canBeLoaded = false;
                },
                success: function (res) {
                    if (currentPage >= res.max) {
                        jQuery("#load-more__button").hide();
                    }
                    canBeLoaded = true;
                    currentPage++;
                    jQuery("#blog-list-inner__inner").append(res.html);
                },
            });
        }
    });        
});
